import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { conditionSchema } from './schemas';

export const conditionsQueryOptions = queryOptions({
  queryKey: QueryKeys.conditions.index,
  queryFn: async () => {
    const response = await request('/conditions');

    const { data: conditions } = apiResourceSchema(conditionSchema.array()).parse(response);

    return conditions;
  },
  staleTime: Infinity,
  gcTime: Infinity,
});

export const useConditions = () => {
  return useSuspenseQuery({
    ...conditionsQueryOptions,
    select: (conditions) => conditions.filter((condition): condition is typeof condition & { deleted: false } => !condition.deleted),
  });
};

export const useConditionsWithTrashed = () => {
  return useSuspenseQuery(conditionsQueryOptions);
};
